// features/schedule/components/ReshootChip.tsx
//
// Dấu "ca này là ĐƠN CHỤP BÙ" trên ô lịch (BE `isReshoot` = đơn có
// reshoot_of_order_id). Đơn bù 0đ sinh ra từ một phiếu khiếu nại: điều phối
// phải nhận ra ngay để không xếp nhầm thành ca bán được tiền, và để ưu tiên
// ekip tử tế cho khách đang bực.
//
// Chỉ là DẤU BÁO, không bấm được — dây nối tới đơn gốc và phiếu khiếu nại nằm
// ở đầu trang chi tiết đơn.

import { RotateCcw } from "lucide-react";
import { cn } from "@/lib/utils";

/** Cùng cặp màu với plan CEO duyệt 20/08/2026 — đỏ nhạt, không đụng bảng màu ca. */
export const RESHOOT_CHIP_BG = "#FFF0F0";
export const RESHOOT_CHIP_FG = "#B74949";

export function ReshootChip({ className }: { className?: string }) {
  return (
    <span
      data-testid="reshoot-chip"
      title="Đơn chụp bù (0đ) của một phiếu khiếu nại"
      className={cn(
        "inline-flex shrink-0 items-center gap-0.5 rounded-full px-1.5 py-px",
        "text-[9px] font-semibold leading-none",
        className,
      )}
      style={{ backgroundColor: RESHOOT_CHIP_BG, color: RESHOOT_CHIP_FG }}
    >
      <RotateCcw size={9} strokeWidth={3} className="shrink-0" />
      Chụp lại
    </span>
  );
}
